import { render, staticRenderFns } from "./ConfirmMail.vue?vue&type=template&id=42b9a458&scoped=true"
import script from "./ConfirmMail.vue?vue&type=script&lang=js"
export * from "./ConfirmMail.vue?vue&type=script&lang=js"
import style0 from "./ConfirmMail.vue?vue&type=style&index=0&id=42b9a458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b9a458",
  null
  
)

export default component.exports